import { RiyadhCardType } from "./card.interface";

export enum LoginFlow {
    password = 'password',
    passcode = 'passcode',
}

export interface IPassword {
    username: string;
    password: string;
}

export interface IPasscode {
    username: string;
    password: string;
}

export interface ISignUpInterface {
    email: string;
    mobile_number: string;
    full_name: string;
    password: string;
    confirmPassword: string;
    card_type: RiyadhCardType | '';
}

export interface ISetPasswordInterface {
    password: string;
    confirmPassword: string;
}

export interface ILoginResponse {
    user_id: string;
    access_token: string;
    expires_in: number;
    refresh_token: string;
    scope: string;
    token_type: string;
    flow?: string;
    user_custom_info?: ICustomInfo;
}

interface IAdmin {
    first_name: string;
    last_name: string;
    email: string;
    mobile: string;
    id: string;
    roles: string[];
    status: string;
    verified_mobile: string;
    verified_email: string;
    created: string;
    modified: string;
    two_fa_required: boolean;
}

interface ICustomToken {
    token: string;
    provider: string;
    scopes: string;
}

export interface IAuthResponse {
    id: string;
    admin_id: string;
    admin: IAdmin;
    flow: string;
    custom_token: ICustomToken;
    user_custom_info: ICustomInfo;
}

export interface ICustomInfo {
    card_type: RiyadhCardType;
}
